import { OptionsControl, Icon, Class, Validations } from './options.model';
import { CondicionControl } from '@app/shared/';

export type TransformText = 'lowercase' | 'uppercase';

export class BaseControl<T> implements OptionsControl<T> {
  value: T;
  key: string | number;
  disabled: boolean;
  skipDisabled: boolean;
  hidden: boolean;
  order: number;
  controlType: string;
  class: Partial<Class> | string;
  size: string;
  label: string;
  hiddenLabel: boolean;
  readonly: boolean;
  // isArray: boolean;
  placeholder: string;
  tooltip?: string;
  describe: string;
  icon: Partial<Icon>;
  validations: Partial<Validations>;
  condictions: Array<CondicionControl>;
  hiddenCondiction: boolean;
  // childs: BaseField<T>[];
  focus: boolean;
  idInput: string;
  modifiable: boolean;
  autoAjustSize?: boolean;
  onFocusOut: (...arg: any[]) => void;

  constructor(options: Partial<OptionsControl<T>>) {
    this.value = options.value;
    this.key = options.key || '';
    this.disabled = !!options.disabled;
    this.skipDisabled = options.skipDisabled;
    this.hidden = !!options.hidden;
    this.order = options.order === undefined ? 1 : options.order;
    this.controlType = options.controlType || '';
    this.size = options.size || '';
    this.class = {
      container: this.getProperty(options.class, 'container') || [],
      label: this.getProperty(options.class, 'label') || [],
      input: this.getProperty(options.class, 'input') || []
    };
    this.icon = {
      name: this.getProperty(options.icon, 'name') || '',
      class: this.getProperty(options.icon, 'class') || [],
      size: this.getProperty(options.icon, 'size') || ''
    };
    this.label = options.label || '';
    this.hiddenLabel = options.hiddenLabel;
    this.readonly = !!options.readonly;
    // this.isArray = !!options.isArray;
    this.placeholder = options.placeholder || '';
    this.tooltip = options.tooltip || '';
    this.describe = options.describe || '';
    this.validations = {
      validators: this.getProperty(options.validations, 'validators') || [],
      messages: this.getProperty(options.validations, 'messages') || {}
    };
    this.condictions = options.condictions;
    this.hiddenCondiction = options.hiddenCondiction;
    // this.childs = options.childs || [];
    this.focus = options.focus;
    this.idInput = options.idInput;
    this.onFocusOut = options.onFocusOut;
  }

  /**
   * Valida si un objeto posee una propiedad.
   *
   * @param {*} obj
   * @param {string} property
   * @returns {(any | null)} - Null en caso de que el objeto no exita o no posea la propiedad.
   * @memberof BaseControl
   */
  private getProperty(obj: any, property: string): any | null {
    if (obj) {
      if (obj.hasOwnProperty(property)) {
        return obj[property];
      }
      return null;
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dynamic-form/shared/controls/base-control.ts